/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface AddWorkRequest {
    workId: string;
}

export interface DeleteWorkRequest {
    workId: string;
}

export interface DeleteWorkForORCIDiDRequest {
    orcidId: string;
    workId: string;
}

export interface GetAllWorksRequest {
    orcidId: string;
}

export interface PublishAllWorksRequest {
    orcidId: string;
}

export interface PublishEmploymentsRequest {
    orcidId: string;
}

export interface UpdateWorkRequest {
    workId: string;
}

/**
 * 
 */
export class SynchronizeApi extends runtime.BaseAPI {

    /**
     * Creates request options for addWork without sending the request
     */
    async addWorkRequestOpts(requestParameters: AddWorkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling addWork().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/core/connect/work/{work_id}`;
        urlPath = urlPath.replace(`{${"work_id"}}`, encodeURIComponent(String(requestParameters['workId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Publish a new work in all ORCID profiles of contributed ORCID iDs.
     */
    async addWorkRaw(requestParameters: AddWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.addWorkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Publish a new work in all ORCID profiles of contributed ORCID iDs.
     */
    async addWork(requestParameters: AddWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addWorkRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteWork without sending the request
     */
    async deleteWorkRequestOpts(requestParameters: DeleteWorkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling deleteWork().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/core/connect/work/{work_id}`;
        urlPath = urlPath.replace(`{${"work_id"}}`, encodeURIComponent(String(requestParameters['workId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a work in ORCID.
     */
    async deleteWorkRaw(requestParameters: DeleteWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteWorkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a work in ORCID.
     */
    async deleteWork(requestParameters: DeleteWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteWorkRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteWorkForORCIDiD without sending the request
     */
    async deleteWorkForORCIDiDRequestOpts(requestParameters: DeleteWorkForORCIDiDRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orcidId'] == null) {
            throw new runtime.RequiredError(
                'orcidId',
                'Required parameter "orcidId" was null or undefined when calling deleteWorkForORCIDiD().'
            );
        }

        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling deleteWorkForORCIDiD().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/core/connect/{orcid_id}/work/{work_id}`;
        urlPath = urlPath.replace(`{${"orcid_id"}}`, encodeURIComponent(String(requestParameters['orcidId'])));
        urlPath = urlPath.replace(`{${"work_id"}}`, encodeURIComponent(String(requestParameters['workId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a work in ORCID profile for a given ORCID iD.
     */
    async deleteWorkForORCIDiDRaw(requestParameters: DeleteWorkForORCIDiDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteWorkForORCIDiDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a work in ORCID profile for a given ORCID iD.
     */
    async deleteWorkForORCIDiD(requestParameters: DeleteWorkForORCIDiDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteWorkForORCIDiDRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllWorks without sending the request
     */
    async getAllWorksRequestOpts(requestParameters: GetAllWorksRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orcidId'] == null) {
            throw new runtime.RequiredError(
                'orcidId',
                'Required parameter "orcidId" was null or undefined when calling getAllWorks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/core/collect/{orcid_id}/works`;
        urlPath = urlPath.replace(`{${"orcid_id"}}`, encodeURIComponent(String(requestParameters['orcidId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all works from the ORCID profile for a given ORCID iD and write them to MMS.
     */
    async getAllWorksRaw(requestParameters: GetAllWorksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.getAllWorksRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get all works from the ORCID profile for a given ORCID iD and write them to MMS.
     */
    async getAllWorks(requestParameters: GetAllWorksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAllWorksRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for publishAllWorks without sending the request
     */
    async publishAllWorksRequestOpts(requestParameters: PublishAllWorksRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orcidId'] == null) {
            throw new runtime.RequiredError(
                'orcidId',
                'Required parameter "orcidId" was null or undefined when calling publishAllWorks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/core/connect/{orcid_id}/works`;
        urlPath = urlPath.replace(`{${"orcid_id"}}`, encodeURIComponent(String(requestParameters['orcidId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Publish all works from MMS to the ORCID profile for a given ORCID iD.
     */
    async publishAllWorksRaw(requestParameters: PublishAllWorksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.publishAllWorksRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Publish all works from MMS to the ORCID profile for a given ORCID iD.
     */
    async publishAllWorks(requestParameters: PublishAllWorksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.publishAllWorksRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for publishEmployments without sending the request
     */
    async publishEmploymentsRequestOpts(requestParameters: PublishEmploymentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orcidId'] == null) {
            throw new runtime.RequiredError(
                'orcidId',
                'Required parameter "orcidId" was null or undefined when calling publishEmployments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/core/connect/{orcid_id}/employments`;
        urlPath = urlPath.replace(`{${"orcid_id"}}`, encodeURIComponent(String(requestParameters['orcidId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Publish (update) all employments from MMS to the ORCID profile for a given ORCID iD.
     */
    async publishEmploymentsRaw(requestParameters: PublishEmploymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.publishEmploymentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Publish (update) all employments from MMS to the ORCID profile for a given ORCID iD.
     */
    async publishEmployments(requestParameters: PublishEmploymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.publishEmploymentsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateWork without sending the request
     */
    async updateWorkRequestOpts(requestParameters: UpdateWorkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling updateWork().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/core/connect/work/{work_id}`;
        urlPath = urlPath.replace(`{${"work_id"}}`, encodeURIComponent(String(requestParameters['workId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Update a work in all ORCID profiles of contributed ORCID iDs.
     */
    async updateWorkRaw(requestParameters: UpdateWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateWorkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a work in all ORCID profiles of contributed ORCID iDs.
     */
    async updateWork(requestParameters: UpdateWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateWorkRaw(requestParameters, initOverrides);
    }

}
